import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { loginSchema, loginValidations } from "./validator";
import { AccountVerifyDialogBox } from "../../components/accountVerificationDialog/index";
import brandLogo from "../../assets/parkingHeroLogo.png";
import { AuthService } from "../../services/auth.service";
import "./styles.scss";
import TextFieldLogin from "../../components/TextFieldLogin";
import { STATUS } from "../../common/constant";
import { ErrorDialog } from "../../components/errorDialog";
import { useDispatch } from "react-redux";
import { setAuthData } from "../../redux/Actions/actions";
import Loader from "../../components/Loader";
import { useLocation } from "react-router-dom";

export const LoginPage: React.FC = () => {

    const [email, setEmail] = useState<string>('')
    const [show, setShow] = useState<boolean>(false);
    const [errorDialog, setErrorDialog] = useState<boolean>(false);
    const [contentToDisplay, setContentToDisplay] = useState<any>({});
    const authenticationService = new AuthService();
    const [loader, setLoader] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const location: any = useLocation();

    const loginSubmit = async (values: any) => {
        try {
            setLoader(true)
            const logindata: typeof loginSchema = {
                email: values?.email.toLowerCase(),
                password: values?.password
            }
            setEmail(values?.email.toLowerCase());
            const loginResponse: any = await authenticationService.Login(logindata);
            loginResponse && setLoader(false)
            if (loginResponse.status === STATUS.SUCCESS) {
                dispatch(setAuthData(loginResponse.data));
                localStorage.setItem("accessToken", loginResponse.data.token.access)
                localStorage.setItem("refreshToken", loginResponse.data.token.refresh)

                if (location?.state?.qrUserId) {
                    const URL = "/timeForAction/" + location?.state?.qrUserId;
                    navigate(URL)
                    return
                }

            } else {

                if (loginResponse.data?.is_email_verified !== undefined && loginResponse.data?.is_phone_verified !== undefined) {
                    if (!loginResponse.data?.is_email_verified && loginResponse.data?.is_phone_verified) {
                        setContentToDisplay({ email: true })
                        setShow(true);
                        return
                    }
                    else if (!loginResponse.data?.is_phone_verified && loginResponse.data?.is_email_verified) {
                        setContentToDisplay({ mobile: true })
                        setShow(true);
                        return
                    }
                    else if (!loginResponse.data?.is_email_verified && !loginResponse.data?.is_phone_verified) {
                        setContentToDisplay({ email_mobile: true })
                        setShow(true);
                        return
                    }
                }
                else {
                    setContentToDisplay(loginResponse.message)
                    setErrorDialog(true)
                }
            }
        }
        catch (error: any) {
            //showNotification(STATUS.FAILURE, error.message)
            setLoader(false)
            console.log('login fail', error)

        }
    }

    const loginFormik = useFormik({ initialValues: loginSchema, validationSchema: loginValidations, onSubmit: loginSubmit })

    return (
        <>
            <div className="login-container">
                <div className="logo-wrapper">
                    <img src={brandLogo} alt="Parking Hero Logo" className="login-logo" />
                </div>
                <h1 className="login-heading">Login</h1>
                <p className="login-subheading">Welcome to Parking Hero!</p>

                <div className="login-form">
                    <form onSubmit={loginFormik.handleSubmit}>
                        <TextFieldLogin
                            label="Email"
                            formik={{ ...loginFormik.getFieldProps("email") }}
                            error={loginFormik.touched.email && loginFormik.errors.email}
                            errorText={loginFormik.errors.email}
                        />
                        <TextFieldLogin
                            type="password"
                            label="Password"
                            formik={{ ...loginFormik.getFieldProps("password") }}
                            error={loginFormik.touched.password && loginFormik.errors.password}
                            errorText={loginFormik.errors.password}
                        />

                        <div className="actions">
                            <p onClick={() => navigate("/forgotPassword")} className="link">
                                Forgot password?
                            </p>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        sx={{
                                            "& .MuiSvgIcon-root": { fontSize: 20 },
                                            color: "#1F2937",
                                            "&.Mui-checked": {
                                                color: "#1F2937",
                                            },
                                        }}
                                    />
                                }
                                label="Keep me logged in"
                            />
                        </div>

                        <button type="submit" className="btn">Login</button>
                    </form>

                    <div className="divider">
                      <p style={{ textAlign: 'center', margin: '10px 0', fontWeight: 500 }}>OR</p>
                    </div>

                    <button className="btn" onClick={() => navigate("/signup")}>
                        Signup
                    </button>
                </div>

                {show && (
                    <AccountVerifyDialogBox
                        show={show}
                        setShow={setShow}
                        contentToDisplay={contentToDisplay}
                        email={email}
                    />
                )}
                {errorDialog && (
                    <ErrorDialog show={errorDialog} setShow={setErrorDialog} message={contentToDisplay} />
                )}
                {loader && <Loader />}
            </div>
        </>
    );

};